import { render, staticRenderFns } from "./CategoriaLista.vue?vue&type=template&id=231695a3"
import script from "./CategoriaLista.vue?vue&type=script&lang=js"
export * from "./CategoriaLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports